import React, {useEffect, useState, useRef} from 'react';
import { ScheduleComponent, ViewsDirective, ViewDirective, Day, Week,  Month, Inject, Resize, DragAndDrop } from '../../components/SimpleSchedule';
import { DatePickerComponent } from '../../components/DatePickerComponent';

import { data } from './data';
import {Header, Loading} from '../../components';
import {Manager} from "../../core";
import {SchedulesStore} from "../../stores/schedules/schedulesStore";
import {Colors} from "../../styles";

type DateType =  "Day" | "Week" | "WorkWeek" | "Month" | "Year" | "Agenda" | "MonthAgenda" | "TimelineDay" | "TimelineWeek" | "TimelineWorkWeek" | "TimelineMonth" | "TimelineYear" | undefined

const PropertyPane = (props: { children: any }) => {
  return <div className="mt-5">{props.children}</div>;
};

export const Calendar = () => {
  const scheduleRef = useRef<any>(null);
  const [schedules, setSchedules] = useState(data);
  const [loading, setLoading] = useState(false);
  // currentThemeColor not used in this component — removed to satisfy linter

  const change = (args: { value: any; }) => {
    if (scheduleRef.current) {
      // normalize date to local midnight to avoid timezone shift showing previous day
      const v = args.value instanceof Date ? args.value : new Date(args.value);
      const normalized = new Date(v.getFullYear(), v.getMonth(), v.getDate());
      // @ts-ignore - keep compatibility with the original API
      scheduleRef.current.selectedDate = normalized;
      // @ts-ignore
      scheduleRef.current.dataBind();
    }
  };

  const onDragStart = (arg: { navigation: { enable: boolean; }; }) => {
    arg.navigation.enable = true;
  };

  useEffect(() => {
    setLoading(true);
    const handlerRequest = async () => {
      try {
        // SchedulesStore.get() returns the mapped events. We want to show canceled events
        // in the calendar but with a different color, so we DO NOT filter them out here.
        const response = await SchedulesStore().get();
        setSchedules(response);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        Manager.RequestError('error.calendar.handlerRequest', e);
      }
    };

    handlerRequest().then((r) => r);
  }, []);

  return loading ? (
    <div style={{position: 'absolute', width: '100%', height: '100%'}}>
      <Loading backgroundColor={Colors.light} type={'bubbles'} color={Colors.green_darker} />
    </div>
  ) : (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg dark:text-gray-200 rounded-3xl">
      <Header category="Aplicativo" title="Calendário" />
      <PropertyPane>
        <table
          className="w-1/5 bg-white dark:bg-transparent"
        >
          <tbody>
          <tr style={{ height: '50px' }}>
            <td style={{ width: '100%' }}>
              <DatePickerComponent
                value={new Date()}
                showClearButton={false}
                placeholder="Selecione ou digite a data"
                floatLabelType="Always"
                change={change}
              />
            </td>
          </tr>
          </tbody>
        </table>
      </PropertyPane>
      <ScheduleComponent
        height="650px"
        ref={scheduleRef}
        selectedDate={new Date()}
        views={['Month','Week','Day']}
        currentView={'Month'}
        eventSettings={{ dataSource: schedules }}
        dragStart={onDragStart}
        firstDayOfWeek={1}
      >
        <ViewsDirective>
          { ['Month','Week','Day'].map((item) => <ViewDirective key={item} option={item as DateType} />)}
        </ViewsDirective>
        <Inject services={[Month, Week, Day, Resize, DragAndDrop]} />
      </ScheduleComponent>
    </div>
  );
};

